export function registerCore() {
    const { createApp: vueCreateApp } = BX.Vue3;
    const componentRegistry = new Map();

    function registerComponent(name, component) {
        componentRegistry.set(name, component);
    }

    function getComponent(name) {
        return componentRegistry.get(name) || null;
    }

    function getAllComponents() {
        const components = {};
        componentRegistry.forEach((component, name) => {
            components[name] = component;
        });
        return components;
    }

    function createApp(options = {}) {
        const {
            el,
            data = {},
            methods = {},
            components = {},
            provide = {},
            setup,
        } = options;

        const container = typeof el === 'string' ? document.querySelector(el) : el;
        if (!container) return null;
        if (container.__vue_app__) return container.__vue_app__;

        const appComponents = { ...getAllComponents(), ...components };
        const app = vueCreateApp({
            data() {
                return {
                    appReady: false,
                    ...data,
                };
            },
            methods: {
                ...methods,
            },
            mounted() {
                this.appReady = true;
            },
            ...(setup ? { setup } : {}),
        });

        app.provide('parentData', data);
        Object.entries(appComponents).forEach(([name, component]) => app.component(name, component));
        Object.entries(provide).forEach(([key, value]) => app.provide(key, value));

        const instance = app.mount(container);
        container.__vue_app__ = instance;
        return instance;
    }

    window.ChelbitVue = {
        registerComponent,
        getComponent,
        getAllComponents,
        createApp,
    };
}